// extracted by mini-css-extract-plugin
export default {"card":"AlertServiceList_card__Tq9JH","addBtn":"AlertServiceList_addBtn__xrxDu"};